// extracted by mini-css-extract-plugin
module.exports = {"container":"no-reviews_container__CZjEB","header":"no-reviews_header__6dAU9","body":"no-reviews_body__NYSGR","icon":"no-reviews_icon__0nXkg"};